module.exports = __webpack_public_path__ + "32e1c2f571a2b69297e436fa4c0e3fe0.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/ss-junior/webfonts/ss-junior.ttf
// module id = 41
// module chunks = 0 1 2 3 4 5 6 7 8 9